import { render, staticRenderFns } from "./PurchaseInvoices.vue?vue&type=template&id=73ac1df2"
import script from "./PurchaseInvoices.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoices.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoices.vue?vue&type=style&index=0&id=73ac1df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports